var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.buttonContainerLinks)?_c('div',{staticClass:"btn-container",class:{
    'is-horizontal': _vm.buttonContainerPositionHorizontal,
    ['is-aligned-to-' + _vm.buttonContainerAlignment]: true,
  }},_vm._l((_vm.buttonContainerLinks),function(link,index){return _c('span',{key:index,class:!link.href && 'hidden'},[_c('kf-link',{attrs:{"type":link.type,"href":_vm.setHref(link),"target":link.target},on:{"handleClick":function($event){return _vm.setAnalyticsData(link)}}},[_vm._v(" "+_vm._s(link.label)+" ")])],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }